import { useState } from 'react';
import TopBar from '@/v3-dashboard/components/TopBar';
import HumanHandoverSidebar from '@/v3-dashboard/components/HumanHandoverSidebar';
import OrganizationDropdown from '@/v3-dashboard/components/OrganizationDropdown';

const LayoutLiveAgent = ({ children }) => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  return (
    <main className="layout-medium-screen d-h-screen flex flex-col w-full">
      {/* Top Header */}
      <TopBar
        isMobileNavOpen={isMobileNavOpen}
        setIsMobileNavOpen={setIsMobileNavOpen}
        navContent={<OrganizationDropdown />}
      />

      {/* Mobile Navigation Drawer */}
      {isMobileNavOpen && (
        <div className="md:hidden w-full h-full flex flex-col overflow-y-auto bg-v3-black-lightest">
          <HumanHandoverSidebar closeMobileSidebar={() => setIsMobileNavOpen(false)} />
        </div>
      )}

      {/* Main content area with sidebar */}
      {!isMobileNavOpen && (
        <div className="flex flex-row w-full h-full min-w-0 overflow-hidden">
          {/* Sidebar - hidden on mobile, visible on md and above */}
          <div className="hidden md:block">
            <HumanHandoverSidebar />
          </div>

          {/* Main content */}
          <div className="w-full flex flex-col h-full min-w-0 overflow-hidden">
            <div className="h-full flex flex-col grow overflow-auto">{children}</div>
          </div>
        </div>
      )}
    </main>
  );
};

export default LayoutLiveAgent;
